module.exports = __webpack_public_path__ + "static/media/step-01.cf766121.png";